module.exports = __webpack_public_path__ + "img/example-cafeteria-menu-fr.fa9b1b2f.webp";